module.exports = __webpack_public_path__ + "static/media/Experience.13ab1d34.png";